import { Auth } from "aws-amplify";

export const signOut = () => {
  Auth.signOut().then(() => {
    localStorage.clear();
    window.location.href = "./"
  });
};
